import type { StageName } from '../domain/stage-name'
import { sanitizeName } from './sanitize-name'

const STAGE_PATH_PARTS: Record<Exclude<StageName, 'Distribution'>, string> = {
  'A-Copy': '2_Acopy',
  'B-Copy': '3_Bcopy',
  Demo: '1_Demo',
  Master: '4_Master',
}

// NAS 上 stage/platform 层路径（相对 storage 根，无尾部斜线）。
export const buildNasStagePlatformPath = (
  deliverablePath: string,
  stageName: StageName,
  platformCode?: string,
): string => {
  if (stageName === 'Distribution') {
    if (!platformCode) {
      throw new Error('Distribution NAS path requires platformCode')
    }
    return `${deliverablePath}/5_Distribution_${sanitizeName(platformCode)}`
  }
  return `${deliverablePath}/${STAGE_PATH_PARTS[stageName]}`
}
